/**
 * IA NAS AGENCIAS — VIDEO 1/9 (Hook)
 * SlideType: hook-series
 * 10s | 720x900 | SEM ÁUDIO
 */
import React from "react";
import {AbsoluteFill, useCurrentFrame, interpolate, Easing, Audio, staticFile} from "remotion";
import {TOKEN_PRESETS, FONT_PRESETS, ACCENT_DEFAULT} from "../../templates/carrossel/EditorialTechNews";

const CLAMP = {extrapolateLeft: "clamp" as const, extrapolateRight: "clamp" as const};
const fadeIn = (frame: number, start: number, end: number) =>
  interpolate(frame, [start, end], [0, 1], { extrapolateRight: CLAMP });
const slideUp = (frame: number, start: number, end: number, dist = 20) =>
  interpolate(frame, [start, end], [dist, 0], { extrapolateRight: CLAMP, easing: Easing.out(Easing.ease) });

export const IA01Hook: React.FC = () => {
  const frame = useCurrentFrame();
  const tokens = TOKEN_PRESETS.dark;
  const accent = "#00DF82";

  return (
    <AbsoluteFill style={{backgroundColor: tokens.bg}}>
      {/* Grid background */}
      <div style={{position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)", backgroundSize: "40px 40px"}} />

      {/* Series label */}
      <div style={{position: "absolute", top: 30, left: 50, opacity: fadeIn(frame, 0, 10), fontFamily: FONT_PRESETS.mono, fontSize: 13, fontWeight: 500, letterSpacing: 2, textTransform: "uppercase", color: tokens.muted}}>
        IA NAS AGENCIAS
      </div>

      {/* Badge */}
      <div style={{position: "absolute", top: 70, left: 50, opacity: fadeIn(frame, 5, 20), transform: `translateX(${interpolate(frame, [5, 20], [-30, 0], {extrapolateRight: CLAMP, easing: Easing.out(Easing.ease)})}px)`, background: accent, borderRadius: 4, padding: "6px 12px"}}>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 13, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", color: "#000"}}>SÉRIE NOVA</span>
      </div>

      {/* Headline */}
      <div style={{position: "absolute", top: 140, left: 50, right: 50, opacity: fadeIn(frame, 5, 20), transform: `translateY(${slideUp(frame, 5, 20)})`, fontFamily: FONT_PRESETS.serif, fontSize: 50, fontWeight: 700, lineHeight: 1.15, color: tokens.headline}}>
        Sua agência vai ficar para trás.
      </div>

      {/* Body */}
      <div style={{position: "absolute", top: 320, left: 50, right: 50, opacity: fadeIn(frame, 20, 35), transform: `translateY(${slideUp(frame, 20, 35)})`, fontFamily: FONT_PRESETS.serif, fontSize: 24, fontWeight: 400, lineHeight: 1.4, color: tokens.body}}>
        A menos que você entenda o que a IA fez com quem não se adaptou.
      </div>

      {/* Footer */}
      <div style={{position: "absolute", bottom: 40, left: 50, right: 50, display: "flex", justifyContent: "space-between", alignItems: "center", opacity: fadeIn(frame, 40, 50)}}>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 15, fontWeight: 400, color: tokens.muted}}>@guilhermeribeiro.ai</span>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 13, fontWeight: 500, color: tokens.muted}}>1/9</span>
      </div>
    </AbsoluteFill>
  );
};
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
